import { useMemo, useSyncExternalStore } from 'react';

import {
  applyServiceWorkerUpdate,
  checkForServiceWorkerUpdate,
  isServiceWorkerUpdateReady,
  subscribeServiceWorkerUpdate,
} from './sw-update-store';

export interface ServiceWorkerUpdate {
  /** A newer build is installed and waiting for the go-ahead. */
  updateReady: boolean;
  /** Activate it and reload this tab. */
  applyUpdate: () => void;
  checkForUpdate: () => void;
}

export function useServiceWorkerUpdate(): ServiceWorkerUpdate {
  const updateReady = useSyncExternalStore(
    subscribeServiceWorkerUpdate,
    isServiceWorkerUpdateReady,
    () => false,
  );
  return useMemo(
    () => ({
      updateReady,
      applyUpdate: applyServiceWorkerUpdate,
      checkForUpdate: checkForServiceWorkerUpdate,
    }),
    [updateReady],
  );
}
